// common
export const PUT_REQUEST = 'consultationAppoint/PUT_REQUEST'
export const PUT_SUCCESS = 'consultationAppoint/PUT_SUCCESS'
export const PUT_FAILURE = 'consultationAppoint/PUT_FAILURE'